import { API_V2_ENDPOINT } from '../../constants';

export const TREATMENT_PLANS_V2_API_BASE = `${API_V2_ENDPOINT}/treatment_plans`;
